import { render, staticRenderFns } from "./DocumentPOSViewCard.vue?vue&type=template&id=6b417956"
import script from "./DocumentPOSViewCard.vue?vue&type=script&lang=js"
export * from "./DocumentPOSViewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports